import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ToolComponentProps } from '../ToolPage/toolComponentProps';
import { NewPromotionPage } from './pages/NewPromotionPage';
import { PromotionListPage } from './pages/PromotionListPage';
import { PromotionOverviewPage } from './pages/PromotionOverviewPage';
import { PromotionSubcategoryPage } from './pages/PromotionSubcategoryPage';

function mergeMatch(
  toolProps: ToolComponentProps,
  routeMatch: { path: string; url: string; params: Record<string, string> },
) {
  return {
    path: routeMatch.path,
    url: routeMatch.url,
    params: { ...toolProps.match.params, ...routeMatch.params },
  };
}

export function PromotionsRouter(props: ToolComponentProps) {
  const { match } = props;
  const baseUrl = match.url;

  return (
    <Switch>
      <Route
        exact
        path={baseUrl}
        render={() => <PromotionListPage {...props} />}
      />
      <Route
        exact
        path={`${baseUrl}/new`}
        render={(routeProps) => (
          <NewPromotionPage {...props} match={mergeMatch(props, routeProps.match)} />
        )}
      />
      <Route
        exact
        path={`${baseUrl}/:id`}
        render={(routeProps) => (
          <PromotionOverviewPage {...props} match={mergeMatch(props, routeProps.match)} />
        )}
      />
      <Route
        path={`${baseUrl}/:id/:subcategory`}
        render={(routeProps) => (
          <PromotionSubcategoryPage {...props} match={mergeMatch(props, routeProps.match)} />
        )}
      />
    </Switch>
  );
}
